import React from 'react';
import Slider from 'react-slick';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBed,
  faBath,
  faMapMarkerAlt,
  faArrowLeft,
  faArrowRight,
} from '@fortawesome/free-solid-svg-icons';
import './style.css';
import { Link } from 'react-router-dom';
import FavoriteButton from '../FavoriteButton';
import { base_url } from '../../Api/apiConfig';

const getImageUrl = (imageUrl) => {
  if (!imageUrl) return null;
  if (String(imageUrl).startsWith('http')) return imageUrl;
  return `${base_url}/storage/${String(imageUrl).replace(/^\/+/, '')}`;
};

const ListingCard = ({ data, url }) => {
  const cardImages = data?.media?.length > 0 ? data.media : (data?.linkedMedia || []);

  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    // autoplay: true,
    // autoplaySpeed: 3000,
    arrows: true,
    prevArrow: <CustomArrow direction="left" />,
    nextArrow: <CustomArrow direction="right" />,
  };

  return (
    <div className="listing-card card shadow-sm rounded overflow-hidden">
      <Link to={`/listing-detial/${data?.id}`} className='redirectLink'></Link>
      <div className="position-relative">
        <Slider {...settings}>
          {cardImages.map((img, idx) => (
            <img
              key={idx}
              src={getImageUrl(img?.image_url)}
              alt={`slide-${idx}`}
              className="img-fluid slider-image"
            />
          ))}
        </Slider>
        <div className="position-absolute top-0 start-0 p-2">
          <FavoriteButton listingId={data?.id} />
        </div>
      </div>
      <div className="p-3">
        <h6 className="mb-1">{data?.title}</h6>
        <p className="mb-2 text-muted">
          <strong>${data?.pricing?.nightly}</strong> Per Night
        </p>
        <div className="d-flex gap-3 align-items-center">
          <span className='text-orange'><FontAwesomeIcon icon={faBed} /> </span><span>{data?.bedrooms?.length}</span>
          <span className='text-orange'><FontAwesomeIcon icon={faBath} /> </span><span>{data?.bathrooms}</span>
          <span className='text-orange'><FontAwesomeIcon icon={faMapMarkerAlt} /></span><span className='lineClamp1'> {data?.location?.city}, {data?.location?.country}</span>
        </div>
      </div>
    </div>
  );
};

const CustomArrow = ({ direction, onClick }) => (
  <div className={`custom-arrow custom-arrow-${direction}`} onClick={onClick}>
    <FontAwesomeIcon icon={direction === 'left' ? faArrowLeft : faArrowRight} />
  </div>
);

export default ListingCard;
